import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import { getRenters } from '../../store/renters/actions';
import { getSites } from '../../store/sites/actions';
import Loader from '../../components/Layout/Loader';
import { SITE_ADD } from '../../constants/routes';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import SiteTable from '../../components/Site/SiteTable';

const styles = () => (
  {
    addButton: {
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      bottom: '3vh',
      right: '3vh',
      zIndex: '1',
    },
  }
);

export class SitesPage extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  state = {
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = {
        ...newState,
        role,
      };
      if (!props.renters && !props.pendingRenters && !props.errorRenters) {
        props.getRenters(props.authUser.ma, role);
      }
      if (!props.sites && !props.pendingSites && !props.errorSites) {
        props.getSites(props.authUser.ma, role);
      }
    }
    return newState;
  }

  render() {
    return (
      <LargePaper>
        <h1 style={stylesDefault.title}>Sites</h1>
        {
          this.state.role === ROLE_ADMIN
          && <Fab
            className={this.props.classes.addButton}
            color="primary"
            component={Link}
            aria-label="add"
            to={SITE_ADD}
          >
            <AddIcon />
          </Fab>
        }
        {
          (this.props.pendingRenters || this.props.pendingSites)
          && <Loader />
        }
        {
          this.props.renters
          && this.props.sites
          && <SiteTable
            renters={this.props.renters}
            sites={this.props.sites}
            role={this.state.role}
          />
        }
      </LargePaper>
    );
  }
}

const authCondition = authUser => !!authUser;

const mapStateToProps = state => (
  {
    authUser: state.users.authUser,
    roles: state.roles.content,
    pendingRenters: state.renters.pending,
    pendingSites: state.sites.pending,
    errorRenters: state.renters.error,
    errorSites: state.sites.error,
    renters: state.renters.content,
    sites: state.sites.content,
  }
);

export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps,
    {
      getRenters,
      getSites,
    },
  ),
  withStyles(styles),
)(SitesPage);



// WEBPACK FOOTER //
// ./src/containers/SitesPage/SitesPage.jsx